/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-03-04 15:48:32                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-04 16:31:37                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * LanguageListItem: Display type list item
*/

/* Imports */
import { Typography } from "@material-tailwind/react";
import ActivitySectorAdminActions from "../../../views/super-admin/views/settings/tabs/activity-sector/ActivitySectorAdminActions";
/***/

/**
* LanguageListItem: Display type list item
* @param type - Language data
* @param onClick - On click event
* @param isLast - Is last item 
*/
export default function ActivitySectorListItem({
  origin,
  onClick,
  onChange,
  isLast = false
}: {
  origin: EasyTech.ActivitySector,
  onClick?: () => void,
  onChange: () => void,
  isLast?: boolean
}) {
  return (
    <tr className={`page-list-item ${isLast && "last"}`} onClick={() => onClick && onClick()}>
      <td>
        <div className="flex gap-2 items-center">
          <Typography>{origin.label}</Typography>
        </div>
      </td>

      <td>
        <div className="flex gap-2 items-center">
          <Typography>{origin.odooId}</Typography>
        </div>
      </td>
      
      <td>
        <div className="flex gap-2 items-center">
          <Typography>{origin.enabled ? "Yes" : "No"}</Typography>
        </div>
      </td>

      <td><ActivitySectorAdminActions activity={origin} onChange={onChange} /></td>
    </tr>
  );
}
/***/
